import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPopup, IPopupInitialState } from "./popupModel";
import {
  activeInactivePopup,
  createPopup,
  deletePopup,
  getAllActivePopup,
  getAllPopup,
  getPopupByID,
  updatePopup,
  uploadPopupImage,
} from "./services/popup.services";

const initialState: IPopupInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PopupID: null,
  PopupList: [],
  PopupDetail: {
    ID: null,
    Title: "",
    URL: "",
    StartDate: "",
    EndDate: "",
    IsActive: 1,
    ImageUpload: "",
  },
};

const popupSlice = createSlice({
  name: "popup",
  initialState,
  reducers: {
    clearPopupDetails: (state) => {
      state.PopupDetail = initialState.PopupDetail;
    },
    setPopupID: (state, action) => {
      state.PopupID = action.payload;
    },
    clearPopupID: (state) => {
      state.PopupID = initialState.PopupID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPopup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPopup.fulfilled,
      (state, action: PayloadAction<IPopup[]>) => {
        state.loading = false;
        state.PopupList = action.payload || [];
      },
    );
    builder.addCase(getAllPopup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PopupList = [];
    });
    builder.addCase(createPopup.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createPopup.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPopup.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updatePopup.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePopup.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePopup.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deletePopup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePopup.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePopup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPopupByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPopupByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PopupDetail = action.payload;
    });
    builder.addCase(getPopupByID.rejected, (state, action) => {
      state.formLoading = false;
      state.PopupDetail = initialState.PopupDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActivePopup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePopup.fulfilled,
      (state, action: PayloadAction<IPopup[]>) => {
        state.loading = false;
        state.PopupList = action.payload || [];
      },
    );
    builder.addCase(getAllActivePopup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PopupList = [];
    });
    builder.addCase(activeInactivePopup.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactivePopup.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactivePopup.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(uploadPopupImage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(uploadPopupImage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(uploadPopupImage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearPopupDetails, clearPopupID, setPopupID } =
  popupSlice.actions;
export default popupSlice.reducer;
